/**
 * A ASSINATURA DA MARCA: o simbolo e o nome de `NOME_PARTES` (aqui, "Lu Barros Studio"), com link
 * para o site.
 *
 * NASCEU NO PE DO MENU em 07/09/2026 (Rail.tsx) e virou peca propria em 12/09/2026, quando o
 * Medicina a levou do menu para a tela Sobre, por pedido do fundador. Uma peca so para os dois
 * lugares, porque o mesmo desenho escrito duas vezes envelhece de um lado so.
 *
 * AS CLASSES VEM DE QUEM USA, e nao daqui: cada lugar decide tamanho, cor base e espacamento, e
 * a classe escrita no arquivo de quem usa e a que o Tailwind do app encontra ao gerar o CSS.
 *
 * ABRE EM OUTRA ABA, e `rel="noopener noreferrer"` nao e formalidade: sem ele a pagina aberta
 * ganha referencia a esta pela `window.opener`. Quem esta dentro do sistema esta trabalhando, e
 * trocar a aba por um site institucional perderia o que a pessoa estava fazendo.
 */
import { DOMINIO, NOME_PARTES } from './brand.js';
import { Simbolo } from './Simbolo.js';

export interface AssinaturaDaPlataformaProps {
  /** Classes do link. */
  readonly className?: string;
  /** Classes do simbolo. */
  readonly classeDoSimbolo?: string;
  /**
   * O nome sai da TELA e fica para o leitor de tela, como no menu recolhido. O caminho
   * contrario, esconder tudo, deixaria um link sem rotulo, mudo para quem nao ve o desenho.
   */
  readonly nomeSoParaLeitor?: boolean;
  /** Marcador para a suite, diferente em cada lugar onde a peca aparece. */
  readonly testId?: string;
}

export function AssinaturaDaPlataforma({
  className = '',
  classeDoSimbolo = '',
  nomeSoParaLeitor = false,
  testId,
}: AssinaturaDaPlataformaProps) {
  return (
    <a
      href={`https://${DOMINIO}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label={`${NOME_PARTES.primeira} ${NOME_PARTES.destaque}, abrir o site da plataforma em nova aba`}
      className={className}
    >
      <Simbolo className={classeDoSimbolo} />
      {nomeSoParaLeitor ? (
        <span className="cx-so-leitor">
          {NOME_PARTES.primeira} {NOME_PARTES.destaque}
        </span>
      ) : (
        <span className="min-w-0 truncate">
          {NOME_PARTES.primeira} <span className="text-marca">{NOME_PARTES.destaque}</span>
        </span>
      )}
    </a>
  );
}
